import { render, staticRenderFns } from "./AssistantSidebar.vue?vue&type=template&id=0e8d74fa&scoped=true"
import script from "./AssistantSidebar.vue?vue&type=script&lang=ts"
export * from "./AssistantSidebar.vue?vue&type=script&lang=ts"
import style0 from "./AssistantSidebar.vue?vue&type=style&index=0&id=0e8d74fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d74fa",
  null
  
)

export default component.exports